import { useContext } from "react"

import { DocumentStateContext, DocumentDispatchContext } from "./DocumentContext.context"

export const useDocumentStateContext = () => {
    const context = useContext(DocumentStateContext)
    if (context === undefined) {
        throw new Error("useDocumentStateContext must be used within an DocumentStateContext")
    }
    return context
}

export const useDocumentDispatchContext = () => {
    const context = useContext(DocumentDispatchContext)
    if (context === undefined) {
        throw new Error("useDocumentDispatchContext must be used within an DocumentDispatchContext")
    }
    return context
}

export const useDocumentContext = () => {
    return [useDocumentStateContext(), useDocumentDispatchContext()]
}
